module.exports = __webpack_public_path__ + "static/media/Receipe2.2c4b4f8c.svg";